import React from 'react';
import PropTypes from 'prop-types';
import { cls } from '../../../packages/components';
import SpecialRibbon from '../../RibbonNew/SpecialRibbon';
import { mapRecommendationToSpecialRibbonProps } from '../fichaHelper';
class VCardRecommendations extends React.PureComponent{

    render(){
        const { recommendations, user, setMetricsEvent = ()=>{}, onRecommendationClick =()=>{}, isLoading} = this.props;
        if(isLoading || recommendations.length === 0 ){
            return null;
        }
        const ribbonProps = mapRecommendationToSpecialRibbonProps(recommendations, onRecommendationClick);
        
        return (
            <div ref='VCardRecommendations' className={cls('vcard-recommendations',{"bg-loading-recommendations":isLoading})}>
                <SpecialRibbon
                    {...ribbonProps}
                    user = {user}
                    setMetricsEvent = {setMetricsEvent}
                />
            </div>
        )
    }
}

VCardRecommendations.propTypes ={
    recommendations: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    setMetricsEvent: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
}

VCardRecommendations.defaultProps  ={
    recommendations: [],
    user: {},
    setMetricsEvent: ()=> {},
    isLoading: false,
}

export default VCardRecommendations;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardRecommendations.jsx